import React from 'react'
import PropTypes from 'prop-types';
import STableContainer from './STableContainer';
import STableRow from './STableRow';

function SimpleTable({
	headers,
	items = [],
	className,
	cellClassName = '',
	columnClasses = [],
	rowClasses = []

}) {
	
	return (
		<STableContainer
			className={className}
			head={headers ? <STableRow
				cellClassNames={columnClasses}
				items={headers}
				cellClassName={cellClassName}
			/>: undefined}
		>
			{items.map( (rowElements, i) => {
				return( rowElements !== null ?
					<STableRow
						key={i}
						items={rowElements}
						cellClassNames={columnClasses}
						cellClassName={cellClassName}
						className={rowClasses[i]}
					/> : null
				)
			})}
		</STableContainer>
	)
}

SimpleTable.propTypes = {
	classes: PropTypes.any,
}

export default SimpleTable;